// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_ingress.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_ingress.proto.
 */
export const file_plugnmeet_ingress: GenFile = /*@__PURE__*/
  fileDesc("ChdwbHVnbm1lZXRfaW5ncmVzcy5wcm90bxIJcGx1Z25tZWV0ImoKEENyZWF0ZUluZ3Jlc3NSZXESKwoKaW5wdXRfdHlwZRgBIAEoDjIXLnBsdWdubWVldC5JbmdyZXNzSW5wdXQSGAoQcGFydGljaXBhbnRfbmFtZRgCIAEoCRIPCgdyb29tX2lkGAMgASgJIn0KEENyZWF0ZUluZ3Jlc3NSZXMSDgoGc3RhdHVzGAEgASgIEgsKA21zZxgCIAEoCRIrCgppbnB1dF90eXBlGAMgASgOMhcucGx1Z25tZWV0LkluZ3Jlc3NJbnB1dBILCgN1cmwYBCABKAkSEgoKc3RyZWFtX2tleRgFIAEoCSouCgxJbmdyZXNzSW5wdXQSDgoKUlRNUF9JTlBVVBAAEg4KCldISVBfSU5QVVQQAUKeAQoNY29tLnBsdWdubWVldEIVUGx1Z25tZWV0SW5ncmVzc1Byb3RvUAFaMmdpdGh1Yi5jb20vbXluYXBhcnJvdC9wbHVnbm1lZXQtcHJvdG9jb2wvcGx1Z25tZWV0ogIDUFhYqgIJUGx1Z25tZWV0ygIJUGx1Z25tZWV04gIVUGx1Z25tZWV0XEdQQk1ldGFkYXRh6gIJUGx1Z25tZWV0YgZwcm90bzM");

/**
 * @generated from message plugnmeet.CreateIngressReq
 */
export type CreateIngressReq = Message<"plugnmeet.CreateIngressReq"> & {
  /**
   * @generated from field: plugnmeet.IngressInput input_type = 1;
   */
  inputType: IngressInput;

  /**
   * @generated from field: string participant_name = 2;
   */
  participantName: string;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;
};

/**
 * Describes the message plugnmeet.CreateIngressReq.
 * Use `create(CreateIngressReqSchema)` to create a new message.
 */
export const CreateIngressReqSchema: GenMessage<CreateIngressReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_ingress, 0);

/**
 * @generated from message plugnmeet.CreateIngressRes
 */
export type CreateIngressRes = Message<"plugnmeet.CreateIngressRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.IngressInput input_type = 3;
   */
  inputType: IngressInput;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: string stream_key = 5;
   */
  streamKey: string;
};

/**
 * Describes the message plugnmeet.CreateIngressRes.
 * Use `create(CreateIngressResSchema)` to create a new message.
 */
export const CreateIngressResSchema: GenMessage<CreateIngressRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_ingress, 1);

/**
 * @generated from enum plugnmeet.IngressInput
 */
export enum IngressInput {
  /**
   * @generated from enum value: RTMP_INPUT = 0;
   */
  RTMP_INPUT = 0,

  /**
   * @generated from enum value: WHIP_INPUT = 1;
   */
  WHIP_INPUT = 1,
}

/**
 * Describes the enum plugnmeet.IngressInput.
 */
export const IngressInputSchema: GenEnum<IngressInput> = /*@__PURE__*/
  enumDesc(file_plugnmeet_ingress, 0);

